import { Component, Input, OnInit, Output, SimpleChanges, EventEmitter } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { NetworkAssetTypes } from '../../../enums/network-asset-types.enum';
import { NetworkAssetMoreOptions } from '../../../models/networkAssetMoreOptions.model';
import { NetworkAssetService } from '../../../services/network-asset.service';

@Component({
  selector: 'app-network-assets-more-options',
  templateUrl: './network-assets-more-options.component.html',
  styleUrls: ['./network-assets-more-options.component.scss'],
  standalone: false
})
export class NetworkAssetsMoreOptionsComponent implements OnInit {
  @Input() borderColor: string = '#007bff'; // Default blue color
  @Input() assetType: string = '';
  @Input() parentId: number = 0;
  @Input() excludeIds: number[] = [];
  @Input() networkAssetType: NetworkAssetTypes;
  @Input() parentNetworkAssetType: NetworkAssetTypes;
  @Output() selectedIdEmiter = new EventEmitter<any>();
  page: number = 1;
  pageSize: number = 6;
  data: NetworkAssetMoreOptions[] = [];
  count: number = 0;
  selectedIds: number[];
  constructor(
    private toastr: ToastrService,
    private networkAssetService: NetworkAssetService
  ) { }

  ngOnInit(): void { }
  ngOnChanges(changes: SimpleChanges) {
    this.page = 1;

    if (this.parentId != 0 && this.parentId != undefined) this.getMoreOptions();
    this.selectedIds = [];
  }
  pageChange(value: any) {
    this.page = value;
    this.getMoreOptions();
  }
  selectId(e: any) {
    if (this.selectedIds.includes(e)) {
      this.selectedIds = this.selectedIds.filter(id => id !== e);
    }
    else {
      if (this.selectedIds.length < 2) {
        this.selectedIds.push(e);
      }
    }
  }

  applyChanges() {
    this.selectedIdEmiter.emit(this.selectedIds)
  }
  getMoreOptions() {
    var obj = {
      parentId: this.parentId,
      networkAssetType: this.networkAssetType,
      parentNetworkAssetType: this.parentNetworkAssetType,
      excludeIds: this.excludeIds,
      page: this.page,
      pageSize: this.pageSize,
    };
    this.networkAssetService.getNetworkAssetOptions(obj).subscribe(
      (data) => {
        var data = data.body.data;
        this.data = data.data;
        this.count = data.count ?? this.count;
      },
      (error) => {
        this.toastr.error('Error occured');
      }
    );
  }
}
